//libs
import React, { memo } from 'react';

//components
import Range from 'shared/components/Filter/components/RangeV2';
import CollapsedFilter from 'shared/components/Filter/components/CollapsedFilter';

//styles
import { Wrapper } from './styles';

//types
interface PriceFilterProps {
  isCollapsedView: boolean;
  filter: Listing.IFilter;
  checkedFilters: { min: number; max: number };
  onClick: VoidFunction;
  onApplyClick: (value: string) => void;
}

const PriceFilter = ({
  isCollapsedView,
  filter,
  checkedFilters,
  onClick,
  onApplyClick,
}: PriceFilterProps) => {
  return (
    <Wrapper isCollapsedView={isCollapsedView}>
      <CollapsedFilter
        title={filter.title}
        isCollapsedView={isCollapsedView}
        onArrowClick={onClick}
      />
      {!isCollapsedView && (
        <Range filter={filter} appliedFilters={checkedFilters} onApplyClick={onApplyClick} />
      )}
    </Wrapper>
  );
};
export default memo(PriceFilter);
